const MuiButton = {
  styleOverrides: {
    root: ({ ownerState, theme }) => {
      return {
        borderRadius: 5,
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none",
        },
      };
    },
    containedPrimary: ({ theme }) => ({
      backgroundColor: theme.palette.custom.primary_button,
      color: theme.palette.custom.primary_button_text,
      "&:hover": {
        backgroundColor: theme.palette.custom.hover_color,
        // backgroundColor: theme.palette.primary[80],
      },
      "&:disabled": {
        backgroundColor: theme.palette.custom.disabled_button,
        color: theme.palette.custom.disabled_button_text,
      },
    }),
    containedSecondary: ({ theme }) => ({
      "&:hover": {
        backgroundColor: theme.palette.secondary[80],
      },
    }),
    outlinedPrimary: ({ theme }) => {
      return {
        // color: theme.palette.base[100],
        color: theme.palette.custom.secondary_button_text,
        // backgroundColor: theme.palette.base[0],
        backgroundColor: theme.palette.custom.secondary_button,
        // borderColor: theme.palette.base[60],
        borderColor: theme.palette.secondary_button_stroke,
        borderRadius: 5,
        boxShadow: "none",
        "&:hover": {
          borderColor: theme.palette.secondary_button_stroke_hover,
          backgroundColor: theme.palette.secondary_button_hover,
          // borderColor: theme.palette.base[60],
          boxShadow: "none",
        },
        "&:disabled": {
          backgroundColor: theme.palette.custom.disabled_button,
          color: theme.palette.custom.disabled_button_text,
        },
      };
    },
    outlined: ({ theme }) => {
      return {
        color: theme.palette.custom.secondary_button_text,
        backgroundColor: theme.palette.custom.secondary_button,
        borderColor: theme.palette.secondary_button_stroke,
        borderRadius: 5,
        boxShadow: "none",
        "&:hover": {
          // borderColor: theme.palette.base[60],
          borderColor: theme.palette.secondary_button_stroke_hover,
          // color: theme.palette.custom.text,
          backgroundColor: theme.palette.custom.secondary_button_hover,
          boxShadow: "none",
        },
      };
    },
    textPrimary: ({ theme }) => {
      return {
        "&:hover": {
          backgroundColor: theme.palette.primary[5],
        },
      };
    },

    sizeSmall: () => {
      return {
        padding: "6px 12px",
      };
    },
    sizeMedium: () => {
      return {
        padding: "8px 16px",
        fontSize: "14px",
      };
    },
    sizeLarge: () => {
      return {
        padding: "12px 22px",
        fontSize: "15px",
      };
    },
  },
};

export default MuiButton;
